module.exports = __webpack_public_path__ + "static/media/404_bubbles.1b86ca17.png";